// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1eWkO","productName":"Table_productName__UjdAM"};